import { render, staticRenderFns } from "./LanguageAbility.vue?vue&type=template&id=34f9234a&scoped=true&"
import script from "./LanguageAbility.vue?vue&type=script&lang=js&"
export * from "./LanguageAbility.vue?vue&type=script&lang=js&"
import style0 from "./LanguageAbility.vue?vue&type=style&index=0&id=34f9234a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f9234a",
  null
  
)

export default component.exports